import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { BuildInfoService } from '@iot-platform/iot-platform-ui';
import { BuildInfo, Environment } from '@iot-platform/models/common';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AppConfig } from './app.config';
import { APP_CONFIG } from './config.module';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly environment: Environment = inject(ENVIRONMENT);
  private readonly config: AppConfig = inject(APP_CONFIG);
  private readonly http: HttpClient = inject(HttpClient);
  private readonly buildInfoService: BuildInfoService = inject(BuildInfoService);

  init(): Observable<AppConfig> {
    return forkJoin([this.buildInfoService.getBuildInfo(), this.getBackendVersion()]).pipe(
      map(([front, back]) => ({ front, back })),
      tap(({ front, back }) => {
        this.config.front = front;
        this.config.back = back;
      })
    );
  }

  getBackendVersion(): Observable<BuildInfo> {
    return this.http.get<BuildInfo>(`${this.environment.api.url}${this.environment.api.endpoints.backendVersion}`).pipe(catchError(() => of(this.config.back)));
  }
}
